import { IncidentClosedOutcome, IncidentStatus } from "@/gql/graphql";
import { BadgeColor } from "@/components/catalyst/badge";

export const incidentStatusColorMap: Record<IncidentStatus, BadgeColor> = {
  [IncidentStatus.Reported]: "yellow",
  [IncidentStatus.ClaimOpen]: "orange",
  [IncidentStatus.Closed]: "zinc",
};

export const incidentOutcomeColorMap: Record<
  IncidentClosedOutcome,
  BadgeColor
> = {
  [IncidentClosedOutcome.NoClaim]: "zinc",
  [IncidentClosedOutcome.Paid]: "emerald",
  [IncidentClosedOutcome.Rejected]: "red",
};
